import React from 'react';
import PropTypes from 'prop-types';
import loadable from 'react-loadable';
import { compose, setStatic } from 'recompose';
import { load as loadLocation } from '../stores/locations';
import { load as loadFormBootstrap } from '../stores/forms/seasonTickets';
import { getConsents } from '../stores/consents';
import { load as loadAuth } from '../stores/auth';

const Loading = props => {
  if (props.error) {
    return (
      <div className="p-loading">
        Error!{' '}
        <button type="button" onClick={props.retry}>
          Retry
        </button>
      </div>
    );
  }
  if (props.pastDelay) {
    return <div className="p-loading">Loading...</div>;
  }
  return null;
};

Loading.propTypes = {
  error: PropTypes.object.isRequired,
  retry: PropTypes.func.isRequired,
  pastDelay: PropTypes.bool.isRequired
};

export const Home = loadable({
  loader: () => import('./Home'),
  loading: Loading
});

export const Landing = compose(
  setStatic('fetchData', (store, route) =>
    store.dispatch(loadLocation(route.params.slug, route.params.country))
  )
)(
  loadable({
    loader: () => import('./Landing'),
    loading: Loading
  })
);

export const LoggedInPage = loadable({
  loader: () => import('./LoggedInPage'),
  loading: Loading
});

export const SeasonTicket = compose(
  setStatic('fetchData', store => store.dispatch(loadFormBootstrap('cornwall')))
)(
  loadable({
    loader: () => import('./SeasonTicket'),
    loading: Loading
  })
);

export const Search = loadable({
  loader: () => import('./Search'),
  loading: Loading
});

export const SearchResults = loadable({
  loader: () => import('./SearchResults'),
  loading: Loading
});

export const LoginWall = compose(
  setStatic('fetchData', (store, match, queryParams) =>
    store.dispatch(getConsents(queryParams, false, match))
  )
)(
  loadable({
    loader: () => import('./LoginWall'),
    loading: Loading
  })
);

export const Register = loadable({
  loader: () => import('./Register'),
  loading: Loading
});

export const ConsentsWall = compose(
  setStatic('fetchData', (store, match, queryParams) =>
    store.dispatch(getConsents(queryParams, false, match))
  )
)(
  loadable({
    loader: () => import('./ConsentWall'),
    loading: Loading
  })
);

export const Revoke = compose(
  setStatic('fetchData', store =>
    store.dispatch(loadAuth()).then(() => store.dispatch(getConsents()))
  )
)(
  loadable({
    loader: () => import('./Revoke'),
    loading: Loading
  })
);
